document.addEventListener("DOMContentLoaded", function () {
  const overlay = document.getElementById("Product-Overlay");
  const buttons = document.querySelectorAll('[data-ref^="formTrigger-"]');

  buttons.forEach(function (button) {
    button.addEventListener("click", function () {
      const dataRef = button.getAttribute("data-ref").replace("formTrigger-", "");
      const drawer = document.getElementById(`ProductDrawer-${dataRef}`);

      overlay.style.display = "block";
      drawer.style.display = "flex";

      // Delay the transition by 0.1 seconds
      setTimeout(() => {
        drawer.style.transition = "right 0.2s ease-in-out";
        drawer.style.right = "0";
        overlay.style.backgroundColor = "rgba(0, 0, 0, 0.5)";
      }, 100);
    });
  });

  // Close button event listener
  const closeButtons = document.querySelectorAll(".drawer__close");
  closeButtons.forEach(function (closeBtn) {
    closeBtn.addEventListener("click", function () {
      const dataDrawer = closeBtn.getAttribute("data-drawer");
      if (dataDrawer) { // Check if dataDrawer is not null
        const drawer = document.getElementById(`ProductDrawer-${dataDrawer}`);
        if (drawer) { // Check if drawer is not null
          closeDrawer(drawer);
        } else {
          console.error(`Drawer with ID 'ProductDrawer-${dataDrawer}' not found.`);
        }
      } else {
        console.error("Attribute 'data-drawer' not found on close button.");
      }
    });
  });

  function closeDrawer(drawer) {
    drawer.style.transition = "right 0.2s ease-in-out";
    drawer.style.right = "-450px";
    overlay.style.backgroundColor = "rgba(0, 0, 0, 0)";

    // Delay setting display to 'none' until after the transition
    setTimeout(() => {
      drawer.style.display = "none";
      overlay.style.display = "none";
    }, 200); // 200ms, same as transition duration
  }

  overlay.addEventListener("click", function () {
    overlay.style.display = "none";
    document.querySelectorAll(".product-drawer").forEach(function (drawer) {
      drawer.style.display = "none";
    });
  });

  // Update position based on screen width
  function updatePosition() {
    document.querySelectorAll(".product-drawer").forEach(function (drawer) {
      if (window.innerWidth <= 450) {
        drawer.style.width = "100%";
        drawer.style.maxWidth = "450px"; // Ensure the drawer doesn't exceed 500px
        drawer.style.height = "100%";
        // drawer.style.position = 'fixed'; // Remove this line
      } else {
        drawer.style.width = "450px";
        drawer.style.height = "100%";
      }
    });
  }

  // Call the function on page load and window resize
  updatePosition();
  window.addEventListener("resize", updatePosition);
});
